<template>
    <div :id="'Q_' + questionData.code" class="question-item">
        <div class="question-item-title"><span v-if="mustShowCodes">[{{ questionData.code }}]</span>
            <span v-if="isAdmin && typeof questionData.decisionItemUpgrade !== 'undefined' && questionData.decisionItemUpgrade !== null" class="icon-decision-item">
                <arrow-up-di-upgrade-icon
                    :color="getDecisionItemColor(questionData.decisionItemUpgrade)"
                    :width="22"
                    :height="22"
                ></arrow-up-di-upgrade-icon>
            </span>

            <span v-if="getDecisionItem(questionData) !== null && getDecisionItem(questionData).icon === null"
                  :style="{'color': getDecisionItemColor(getDecisionItem(questionData)) }"
            >*</span>
            <span v-if="getDecisionItem(questionData) && getDecisionItem(questionData).icon !== null"
                  class="icon-decision-item"
                  v-html="iconValue">
            </span>

            <span :id="'Q_NAME_' + questionData.code"
                  v-bind:style="{'color': getDecisionItemColor(getDecisionItem(questionData))}"
                  class="question-title"
            >{{ questionData.name }}
            </span>

            <help-icon  v-if="questionData.description"
                        :svg-fill-class="'svg-block-background-color'"
                        @click.native="openQuestionDescriptionPopup(questionData)"
                        :id="'Q_HELP_' + questionData.code"
                        class="float-right question-description-icon"
            ></help-icon>
            <question-description-popup
                    v-if="questionForDescriptionPopup"
                    :questionData="questionForDescriptionPopup"
                    @onCloseQuestionDescPopup="hideQuestionDescriptionPopup()"
            ></question-description-popup>

        </div>
        <span v-show="mustShowFullQuestion" :id="'Q_TEXT_' + questionData.code" >{{ questionData.text }}</span><br />
        <v-select
                :id="'question-dropdown-' + questionData.code"
                :ref="'question-dropdown-' + questionData.code"
                :items="answerOptions"
                item-text="text"
                item-value="code"
                color="primary"
                :disabled="questionData.answeredByVitalParam !== null"
                v-model="questionData.providedAnswer"
                placeholder="Select answer "
                @change="handleChangeAnswer"
                @click.native="handleQuestionClick"
                class="select-value symptom-question-answers-dropdown"
                v-bind:class="{
                    'answer-value': questionData.providedAnswer,
                    'question-highlighted': (this.isNavAvailable === true && this.shortcutNav.isPanelHighlight === false && mustShowVitalParamsForm === false)
                }"
                :style="{
                    cursor: questionData.answeredByVitalParam !== null ? 'pointer': '',
                    'pointer-events': questionData.answeredByVitalParam !== null ? 'auto': ''
                }"
                :max-height="dropdownMaxHeight"
            >
            <template slot="selection" slot-scope="data">
                <span v-if="mustShowCodes" class="font-size-small font-weight-light">
                    [{{ data.item.code }}]&nbsp;
                </span>
                <span v-bind:class="{'empty-answer-option': questionData.providedAnswer === null}">{{ data.item.text }}</span>
            </template>
            <template slot="item" slot-scope="data">
                <span class="question-answer-option" :id="'A_' + data.item.code"> {{ data.item.text }}</span>
            </template>
        </v-select>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';
import HelpIcon from "../svg/shared/helpIcon";
import QuestionDescriptionPopup from "./QuestionDescriptionPopup";
import Vue from "vue";
import ArrowUpDiUpgradeIcon from "../svg/shared/ArrowUpDiUpgradeIcon.vue";

const SELECT_OPTION_ELEMENT_HEIGHT = 40;

    export default {
        components: {
            ArrowUpDiUpgradeIcon,
            HelpIcon,
            QuestionDescriptionPopup
        },
        name: 'SymptomQuestionItem',
        data () {
            return {
                vSelectObj: null,
                iconValue: '',
                colors: '',
                questionForDescriptionPopup: null,
                arrowDownPlugin: Vue.ArrowDown.arrowDownSvg,
                themeColor: '' // @TODO Do we need this?
            }
        },
        props: {
            questionData: {
                type: Object,
                required: true
            },
            mustShowFullQuestion: {
                type: Boolean,
                default: true
            },
            shortcutNav: {}
        },
        computed: {
            ...mapGetters({
                mustShowCodes: 'UserStore/getDebugMustShowCodes',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue',
                getCurrentGuiThemeColor: 'ThemeStore/getCurrentGuiThemeColor',
                getIsThemeDarkActive : 'TranslationStore/getIsThemeDarkActive',
                getDecisionItemColor: 'ThemeStore/getDecisionItemColor',
                isAdmin: 'UserStore/getIsAdmin',
                di1PriorityLevelHighest: 'SymptomsQuestionsStore/getDi1PriorityLevelHighest',
                mustShowVitalParamsForm: 'VitalParametersStore/getMustShowVitalParamsForm',
            }),

            answerOptions () {
                let answerList = this.questionData.answers;
                answerList.unshift({
                    code: null,
                    id: null,
                    text: this.text("api.assessment.select.answer")
                });

                const decisionItem1 = this.getDecisionItem(this.questionData);

                if (decisionItem1 !== null) {

                    this.colors = this.getDecisionItemColor(decisionItem1);

                    if (decisionItem1.icon) {
                        this.iconValue = decisionItem1.icon.replace(/COLOR_PLACEHOLDER/gi, this.colors);
                    }
                }
              return answerList;
            },

            isNavAvailable () {
                return (this.shortcutNav.isKeyboardNav === true
                        && this.shortcutNav.crtQuestion === this.questionData.code
                        && (this.shortcutNav.crtPanel === 'START_QUESTIONS'
                            || this.shortcutNav.crtPanel === 'GENERAL_QUESTIONS'
                            || this.shortcutNav.crtPanel === 'SYMPTOMS_PANEL'
                            || this.shortcutNav.crtPanel === 'SHARED_QUESTIONS'));
            },

            isQuestionHighlighted() {
                return (this.isNavAvailable === true && this.shortcutNav.isPanelHighlight === false);
            },

            dropdownMaxHeight() {

                const dropdownHeightOffset = 120; // The difference between the page height and the maximum height of the dropdown (the total amount of space that won't be used by the dropdown above or below the dropdown).
                const maxDropdownAllowedHeight = 780;

                let maxNumOfWholeOptions = Math.floor((this.$vuetify.breakpoint.height - dropdownHeightOffset) / SELECT_OPTION_ELEMENT_HEIGHT);

                // We add half of an option height because if the scrollbar is needed, we want half of option to be
                // displayed at the end of the visible dropdown list (that is shown without scrolling), so the user
                // can easily see that there are more options in the list and he/she just has to scroll down the list.
                let maxHeight = (maxNumOfWholeOptions * SELECT_OPTION_ELEMENT_HEIGHT) + (SELECT_OPTION_ELEMENT_HEIGHT / 2);

                if (maxHeight > maxDropdownAllowedHeight) {
                    maxHeight = maxDropdownAllowedHeight;
                }

                return maxHeight;
            },

            getDecisionItem() {

                return (question) => {

                    const decisionItem = typeof question.decisionItem !== 'undefined' ? question.decisionItem : null;
                    const decisionItemUpgrade = typeof question.decisionItemUpgrade !== 'undefined' ? question.decisionItemUpgrade : null;

                    if (this.isAdmin) {
                        return decisionItem;
                    }
                    else {

                        if (decisionItem !== null && decisionItemUpgrade !== null) {

                            if (decisionItemUpgrade.priorityLevel === this.di1PriorityLevelHighest) {

                                return decisionItemUpgrade;
                            }
                            else if (decisionItem.priorityLevel === this.di1PriorityLevelHighest) {

                                return decisionItem;
                            }
                            else {
                                return null;
                            }
                        }
                        else if (decisionItem === null && decisionItemUpgrade !== null) {

                            return decisionItemUpgrade.priorityLevel === this.di1PriorityLevelHighest ? decisionItemUpgrade : null;
                        }
                        else if (decisionItem !== null && decisionItemUpgrade === null) {

                            return decisionItem.priorityLevel === this.di1PriorityLevelHighest ? decisionItem : null;
                        }
                        else {
                            return null;
                        }
                    }
                }
            }

        },

        watch: {
            questionData (newVal, oldVal) {
                if (newVal) {

                    this.$nextTick(() => {
                        const questionItem = document.getElementById('Q_' + newVal.code);
                        let selectedInput = questionItem.querySelectorAll('.select-value:not(.answer-value)');

                        for(let i = 0; i < selectedInput.length; i++) {

                            let selectedInputIcon = selectedInput[i].getElementsByClassName('input-group__append-icon');
                            selectedInputIcon[0].innerHTML = this.arrowDownPlugin();
                        }

                        let answeredSelectedInput = document.querySelectorAll('.answer-value');
                        for(let i = 0; i < answeredSelectedInput.length; i++) {
                            let selectedAnsweredInputIcon = answeredSelectedInput[i].getElementsByClassName('input-group__append-icon');
                            selectedAnsweredInputIcon[0].innerHTML = '';
                        }
                    });

                }
            }
        },

        methods: {
            handleChangeAnswer(selectedAnswerCode) {
                this.$emit('onProvideQuestionAnswer', {
                    newProvidedAnswerCode: selectedAnswerCode,
                    questionCode: this.questionData.code
                });
            },

            handleQuestionClick() {
                // When a question is preAnswered by a VitalParameter open the VitalParametersDropdown and set the focus to that question
                if (this.questionData.answeredByVitalParam != null) {
                    this.$refs['question-dropdown-' + this.questionData.code].$refs.input.blur();
                    this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);
                    this.$store.commit('VitalParametersStore/setFocusVitalParameter', this.questionData.answeredByVitalParam);
                }

                this.scrollSelectedOptionIntoView();

                this.$emit('emitQuestionClick', {
                    questionCode: this.questionData.code
                });
            },

            scrollSelectedOptionIntoView() {

                // Show all select options.
                if (this.vSelectObj.items && this.vSelectObj.items.length > 20) {
                    // By default, Vuetify only shows the first 20 entries in the dropdown list and adds more entries on scroll,
                    // but we will force Vuetify to display all entries from the beginning, not only the first 20.
                    this.vSelectObj.lastItem = this.vSelectObj.items.length;
                }

                this.$nextTick(() => {
                    let optionListElems = this.navGetVSelectEntryList();

                    if (optionListElems !== null) {

                        let selectedOptionElemIndex = optionListElems.findIndex((optionElem) => {
                            return optionElem.isActive;
                        });

                        if (selectedOptionElemIndex < 0) {
                            selectedOptionElemIndex = 0;
                        }

                        this.vSelectObj.$refs.menu.listIndex = selectedOptionElemIndex; // Set selected option index.

                        if (selectedOptionElemIndex > 0) {
                            let optionListScrollableContainer = this.vSelectObj.$refs.menu.$refs.content;

                            let computedScrollIntoViewPosition = ((selectedOptionElemIndex - 1) * SELECT_OPTION_ELEMENT_HEIGHT); // Variant 1: Scroll selected to the top of visible area, to be in sync with the default vuetify behavior on pressing up/down keyboard arrows.
                            // let computedScrollIntoViewPosition = ((selectedOptionElemIndex + 1) * SELECT_OPTION_ELEMENT_HEIGHT) - parseInt(optionListScrollableContainer.style.maxHeight) + (SELECT_OPTION_ELEMENT_HEIGHT/2); // Variant 2: Scroll selected to the bottom of visible area, to reduce the amount of scrolling.

                            setTimeout(() => { // Wait for animation.
                                this.UtilitiesPlugin.smoothScrollElementTo(computedScrollIntoViewPosition, optionListScrollableContainer);
                            }, 501);
                        }
                    }
                });
            },

            openQuestionDescriptionPopup(question) {
                this.questionForDescriptionPopup = question;
            },
            hideQuestionDescriptionPopup() {
                this.questionForDescriptionPopup = null;
            },

            customOnKeyDown(e) {

                if (this.questionData.answeredByVitalParam != null && 13 === e.keyCode) {
                    this.$store.commit('VitalParametersStore/setMustShowVitalParamsForm', true);
                    this.$store.commit('VitalParametersStore/setFocusVitalParameter', this.questionData.answeredByVitalParam);
                    return;
                }

/*
                Vuetify Code:

                // If enter, space, up, or down is pressed, open menu
                if (!this.menuIsActive && [13, 32, 38, 40].includes(e.keyCode)) {
                    e.preventDefault();
                    return this.showMenu();
                }
*/

                // If Menu Closed AND space, up, or down is pressed, DO NOT open menu
                // For Enter (13) let Vuetify to open it
                if (!this.vSelectObj.menuIsActive && [32, 38, 40].includes(e.keyCode)) {
                    return;
                }

/*
                Vuetify Code:

                // If tab - select item or close menu
                if (e.keyCode === 9) return this.onTabDown(e);
*/

                // If tab - DO NOTHING
                if (e.keyCode === 9) {
                    return;
                }

                // On CTRL + UP/DOWN Jump at first/last entry
                if (this.vSelectObj.menuIsActive && [38, 40].includes(e.keyCode) && e.ctrlKey === true) {

                    let entryList = this.navGetVSelectEntryList();
                    if (entryList != null && entryList.length > 0) {

                        // UP
                        if (e.keyCode === 38) {
                            this.vSelectObj.$refs.menu.listIndex = 0;
                            return;
                        }
                        // DOWN
                        else if (e.keyCode === 40) {
                            this.vSelectObj.$refs.menu.listIndex = entryList.length - 1;
                            return;
                        }
                    }
                }

                let originalResponse = this.originalOnKeyDown(e);

                // For Enter (13) let Vuetify to open it and We select the Selected entry or put on the first position and scroll the selected entry into view
                if (this.vSelectObj.menuIsActive && 13 === e.keyCode) {
                    this.scrollSelectedOptionIntoView();
                }

                if (this.vSelectObj.menuIsActive && [37, 38, 39, 40].includes(e.keyCode)) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }

                return originalResponse;
            },

            navGetVSelectEntryList() {

                let entryList = null;

                if (this.vSelectObj.$refs != null
                    && this.vSelectObj.$refs.menu != null
                    && this.vSelectObj.$refs.menu.$children != null
                    && this.vSelectObj.$refs.menu.$children[0] != null
                    && this.vSelectObj.$refs.menu.$children[0].$children != null
                    && this.vSelectObj.$refs.menu.$children[0].$children[0] != null
                    && this.vSelectObj.$refs.menu.$children[0].$children[0].$children != null) {

                    entryList = this.vSelectObj.$refs.menu.$children[0].$children[0].$children;
                }

                return entryList;
            },

            customToggleMenu() {

                // Function called only at Click to Open/Close a VSelect
                // Considered Mouse Interaction => Exist from Shortcut Navigation
                this.shortcutNav.isKeyboardNav = false;

                // At mouse interaction, when open/collapse vSelect with icon, make this Q as current one
                this.handleQuestionClick();

                this.originalToggleMenu();

            }
        },

        created() {

            const decisionItem1 = this.getDecisionItem(this.questionData);

            if (decisionItem1 !== null) {
                this.colors = this.getDecisionItemColor(decisionItem1);
                if (decisionItem1.icon) {
                    this.iconValue = decisionItem1.icon.replace(/COLOR_PLACEHOLDER/gi, this.colors);
                }
            }
        },

        mounted() {

            this.vSelectObj = this.$refs['question-dropdown-' + this.questionData.code];

            this.originalOnKeyDown = this.vSelectObj.onKeyDown;
            this.vSelectObj.onKeyDown = this.customOnKeyDown;

            this.originalToggleMenu = this.vSelectObj.toggleMenu;
            this.vSelectObj.toggleMenu = this.customToggleMenu;

            // Set the VSelect Element where to apply the border color
            this.vSelectElem = null;

            let elemArr = this.vSelectObj.$el.getElementsByClassName("input-group__input");
            if (elemArr != null && elemArr.length > 0) {
                this.vSelectElem = elemArr[0];
            }

            let selectedInput = document.querySelectorAll('.select-value:not(.answer-value):not(.vital-params)');
            for (let i = 0; i < selectedInput.length; i++) {
                let selectedInputIcon = selectedInput[i].getElementsByClassName('input-group__append-icon');
                selectedInputIcon[0].innerHTML = this.arrowDownPlugin();
            }

        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>

    .item-mobile, .answer-radio {
        width: 100%;
        padding: 7px 5px;
        border-bottom: 1px solid $color-gray-lightest;
    }

    .item-mobile {

        &:hover {
            cursor: pointer;
        }

        .icon {
            float: right;
            position: relative;
            top: 10px;
        }

        .question-text {
            font-size: $font-size-default;
        }
    }

    .question-item span.dialog-name {
        color: $color-headings-text;
        font-weight: $font-weight-bold;
    }

    .dialog--scrollable .card {
        padding: 0 5px;
    }

    .question-description-icon {
        cursor: pointer;
    }

    .question-name{
        font-weight: $font-weight-bold;
    }

</style>



// WEBPACK FOOTER //
// src/common/components/shared/SymptomQuestionItem.vue